import type { BreadcrumbPartSibling } from '@ipen-portal/plugin-navigation-react';
import type { ComponentProps, FC, PropsWithChildren } from 'react';

import { Link } from '@backstage/core-components';
import { ResolvedIcon } from '@ipen-portal/plugin-common-react';
import { ListItemIcon, ListItemText, MenuItem } from '@mui/material';
import { tss } from 'tss-react/mui';

const useStyles = tss.create(({ theme }) => ({
  menuItem: {
    color: theme.palette.common.black,
  },
}));

type Props = Pick<ComponentProps<typeof MenuItem>, 'onClick'> & {
  sibling: Omit<BreadcrumbPartSibling, 'fullTitle'>;
};

export const SiblingMenuItem: FC<PropsWithChildren<Props>> = ({
  children,
  onClick,
  sibling,
}) => {
  const { classes } = useStyles();
  return (
    <MenuItem
      className={classes.menuItem}
      onClick={onClick}
      selected={sibling.current}
      title={sibling.title}
      {...(typeof sibling.link === 'string'
        ? { component: Link, to: sibling.link }
        : undefined)}
    >
      <ListItemIcon>
        <ResolvedIcon icon={sibling.icon} size={16} />
      </ListItemIcon>
      <ListItemText>{sibling.title}</ListItemText>
      {children}
    </MenuItem>
  );
};
